if (
  typeof customElements.get('lamyss-shop-the-look') ===
  'undefined'
) {
  class LamyssShopTheLook extends HTMLElement {
    constructor() {
      super();

      this.track = null;
      this.previousButton = null;
      this.nextButton = null;
      this.controls = null;
      this.resizeObserver = null;
      this.rafId = null;

      this.handlePreviousClick =
        this.handlePreviousClick.bind(this);

      this.handleNextClick =
        this.handleNextClick.bind(this);

      this.handleScroll =
        this.handleScroll.bind(this);

      this.handleKeydown =
        this.handleKeydown.bind(this);

      this.updateControls =
        this.updateControls.bind(this);
    }

    connectedCallback() {
      this.track = this.querySelector(
        '[data-carousel-track]'
      );

      if (!this.track) return;

      this.previousButton = this.querySelector(
        '[data-carousel-previous]'
      );

      this.nextButton = this.querySelector(
        '[data-carousel-next]'
      );

      this.controls = this.querySelector(
        '[data-carousel-controls]'
      );

      this.previousButton?.addEventListener(
        'click',
        this.handlePreviousClick
      );

      this.nextButton?.addEventListener(
        'click',
        this.handleNextClick
      );

      this.track.addEventListener(
        'scroll',
        this.handleScroll,
        {
          passive: true
        }
      );

      this.track.addEventListener(
        'keydown',
        this.handleKeydown
      );

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(
          this.updateControls
        );

        this.resizeObserver.observe(this.track);
      } else {
        window.addEventListener(
          'resize',
          this.updateControls
        );
      }

      requestAnimationFrame(this.updateControls);
    }

    disconnectedCallback() {
      this.previousButton?.removeEventListener(
        'click',
        this.handlePreviousClick
      );

      this.nextButton?.removeEventListener(
        'click',
        this.handleNextClick
      );

      this.track?.removeEventListener(
        'scroll',
        this.handleScroll
      );

      this.track?.removeEventListener(
        'keydown',
        this.handleKeydown
      );

      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      } else {
        window.removeEventListener(
          'resize',
          this.updateControls
        );
      }

      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
      }
    }

    handlePreviousClick() {
      this.scrollByCard(-1);
    }

    handleNextClick() {
      this.scrollByCard(1);
    }

    handleKeydown(event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.scrollByCard(-1);
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.scrollByCard(1);
      }
    }

    handleScroll() {
      if (this.rafId) return;

      this.rafId = requestAnimationFrame(() => {
        this.updateControls();
        this.rafId = null;
      });
    }

    getScrollAmount() {
      const firstCard = this.track?.querySelector(
        '.lamyss-shop-the-look__card'
      );

      if (!firstCard || !this.track) {
        return this.track?.clientWidth || 0;
      }

      const trackStyles = window.getComputedStyle(
        this.track
      );

      const gap = Number.parseFloat(
        trackStyles.columnGap ||
          trackStyles.gap ||
          '0'
      );

      return (
        firstCard.getBoundingClientRect().width +
        gap
      );
    }

    scrollByCard(direction) {
      if (!this.track) return;

      const reducedMotion = window
        .matchMedia(
          '(prefers-reduced-motion: reduce)'
        )
        .matches;

      this.track.scrollBy({
        left: this.getScrollAmount() * direction,
        behavior: reducedMotion ? 'auto' : 'smooth'
      });
    }

    updateControls() {
      if (!this.track) return;

      const maxScrollLeft = Math.max(
        0,
        this.track.scrollWidth -
          this.track.clientWidth
      );

      const hasOverflow = maxScrollLeft > 2;

      const currentScrollLeft = Math.max(
        0,
        this.track.scrollLeft
      );

      if (this.controls) {
        this.controls.hidden = !hasOverflow;
      }

      if (this.previousButton) {
        this.previousButton.disabled =
          !hasOverflow ||
          currentScrollLeft <= 2;
      }

      if (this.nextButton) {
        this.nextButton.disabled =
          !hasOverflow ||
          currentScrollLeft >= maxScrollLeft - 2;
      }
    }
  }

  customElements.define(
    'lamyss-shop-the-look',
    LamyssShopTheLook
  );
}